export const EDIT_USER_PROFILE = 'EDIT_USER_PROFILE'
export const editProfileStateAction = (userProfile) => {
  return {
    type: 'EDIT_USER_PROFILE',
    payload: userProfile,
  }
}

export const FETCH_PRODUCTS_IN_CART = 'FETCH_PRODUCTS_IN_CART'
export const fetchProductsInCartAction = (products) => {
  return {
    type: 'FETCH_PRODUCTS_IN_CART',
    payload: products,
  }
}
export const FETCH_PRODUCTS_IN_FAVORITE = 'FETCH_PRODUCTS_IN_FAVORITE'
export const fetchProductsInFavoriteAction = (products) => {
  return {
    type: 'FETCH_PRODUCTS_IN_FAVORITE',
    payload: products,
  }
}

export const SIGN_IN = 'SIGN_IN'
export const signInAction = (userState) => {
  return {
    type: 'SIGN_IN',
    /*payload:{
            isSignedIn: true,
            role: userState.role,
            uid: userState.uid,
            username: userState.username
        }*/
    payload: userState,
  }
}

export const SIGN_OUT = 'SIGN_OUT'
export const signOutAction = () => {
  return {
    type: 'SIGN_OUT',
    payload: {
      isSignedIn: false,
      // role:"",
      // uid:"",
      // username:""
    },
    // payload: null,
  }
}

export const UPDATE_USER_STATE = 'UPDATE_USER_STATE'
export const updateUserStateAction = (userState) => {
  return {
    type: 'UPDATE_USER_STATE',
    payload: userState,
  }
}

export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const updateProfileAction = (newState) => {
  return {
    type: UPDATE_PROFILE,
    payload: {
      usernumber: newState.usernumber,
      username: newState.username,
      departmentid: newState.departmentid,
      departmentname: newState.departmentname,
      role: newState.role,
      uid: newState.uid,
      order_base_id: newState.order_base_id,
      order_base_name: newState.order_base_name,
      order_department_id: newState.order_department_id,
      order_department_name: newState.order_department_name,
      email: newState.email,
      order_email: newState.order_email,
    },
  }
}
